import { mapState } from '../state/map-state.js';

/**
 * @typedef {import('../types/jsdoc-types.js').ReactiveControllerHost} ReactiveControllerHost
 */

export class MapStateController {
  /**
   * @param {ReactiveControllerHost} host
   * @param {{ onChange?: (() => void) }} [options]
   */
  constructor(host, options = {}) {
    this.host = host;
    this._onChange = options.onChange || null;
    this._unsubscribe = null;
    host.addController(this);
  }

  get state() {
    return mapState;
  }

  hostConnected() {
    mapState.reset();
    this._unsubscribe = mapState.subscribe(() => {
      this._onChange?.();
      this.host.requestUpdate();
    });
  }

  hostDisconnected() {
    this._unsubscribe?.();
    this._unsubscribe = null;
  }
}
